import apiClient from './client'
import type { GroupMonthlyPayments } from '../../../shared/src/types/monthly_payment'

export type { GroupMonthlyPayments, MonthlyPaymentStatus } from '../../../shared/src/types/monthly_payment'
export const monthlyPaymentsApi = {
  getGroupMonthly: async (groupId: string, month: string): Promise<GroupMonthlyPayments> => {
    const { data } = await apiClient.get(`/groups/${groupId}/monthly-payments/${month}`)
    return data
  },
  togglePayment: async (groupId: string, athleteId: string, month: string, isPaid: boolean): Promise<void> => {
    await apiClient.put(`/groups/${groupId}/monthly-payments/${athleteId}/${month}`, { is_paid: isPaid })
  },
  getMonthlyPrice: async (groupId: string): Promise<{ monthly_price: number | null }> => {
    const { data } = await apiClient.get(`/groups/${groupId}/monthly-price/`)
    return data
  },
  setMonthlyPrice: async (groupId: string, monthlyPrice: number): Promise<void> => {
    await apiClient.put(`/groups/${groupId}/monthly-price/`, { monthly_price: monthlyPrice })
  },
}
